const NO_COLOR = "NO_COLOR";
export {
  NO_COLOR
};
//# sourceMappingURL=constants.js.map
